import {
  COLOR_BLACK_HAZE,
  COLOR_BLACK_PERL,
  COLOR_DENIM,
  COLOR_HUMMINGBIRD,
  COLOR_WHITE,
  FONT_SIZE_16_PX,
  FONT_WEIGHT_NORMAL,
  FONT_WEIGHT_SEMI_BOLD,
} from 'popTheme';
import backgroundImage from './questionCardBackground.svg';

export const container = {
  maxWidth: '1020px',
  margin: 'auto',
};
export const navigation = {
  position: 'absolute',
  bottom: '0.5rem',
  display: 'flex',
  justifyContent: 'space-between',
  width: '90%',
};
export const button = {
  background: COLOR_HUMMINGBIRD,
  height: { xs: '2.25rem', md: '2.75rem' },
  borderRadius: '0.375rem',
  color: COLOR_DENIM,
  fontWeight: FONT_WEIGHT_SEMI_BOLD,
  px: { xs: '0.5rem', md: '0.625rem' },
  py: { xs: '1.25rem', md: '1.5rem' },
};
export const submitText = {
  color: COLOR_WHITE,
};

export const subQuestion = {
  fontSize: { xs: '1rem', md: '1.25rem' },
  pb: { xs: '0.625rem', md: '1.5rem' },
};

export const card = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: 'cover',
  borderRadius: '0.75rem',
  boxSizing: 'border-box',
  height: { xs: '36.4375rem', sm: '25.875rem', md: '32.375rem', lg: '35.875rem' },
  textAlign: 'center',
  fontWeight: FONT_WEIGHT_NORMAL,
  fontSize: FONT_SIZE_16_PX,
  gap: FONT_SIZE_16_PX,
  mx: FONT_SIZE_16_PX,
  paddingBlock: FONT_SIZE_16_PX,
  paddingInline: { xs: '0.75rem', sm: '5rem' },
  overflowY: 'auto',
};

export const questionCard = {
  backgroundColor: COLOR_BLACK_HAZE,
  color: COLOR_DENIM,
};
export const descriptiveCard = {
  backgroundColor: COLOR_BLACK_PERL,
  color: COLOR_BLACK_HAZE,
};
